module.exports = __webpack_public_path__ + "static/img/banner2.689d75f2.png";